<template>
  <div>
    <section class="hero is-info is-bold">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">
            <i class="fa fa-bar-chart"></i>&nbsp;&nbsp;{{ $t("blocks.blocks")}}
          </h1>
          <h2 class="subtitle">
            {{ $t("blocks.desc") }}
          </h2>
        </div>
      </div>
    </section>
    <div class="section">
      <div class="container">
        <div class="content">
          <!-- total blocks -->
          <h2>{{ $t("blocks.total_blocks") }}</h2>
          <live-tag/>
          <h2>
            <span class="heading">{{ $t("blocks.current_block_count") }}</span>
            <b>{{ $utils.addComma(blockHeight) }}</b>
          </h2>
          <br>
          <line-chart :data="blockData" :options="blockOptions"></line-chart>
          <br>
          <br>
          <hr>
          <!-- -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LineChart from '../components/layout/LineChart'
  import LiveTag from '../components/layout/LiveTag'
  import { mapState } from 'vuex'

  export default {
    name: 'BlocksOverview',
    components: { LiveTag, LineChart },
    mounted () {
      this.$store.dispatch('loadBlocksOverview')
    },
    computed: {
      ...mapState(['blocksOverview', 'chainStatus']),
      blockArray () {
        return this.blocksOverview.slice(0)
      },
      blockHeight () {
        return this.chainStatus.blockHeight
      },
      blockData () {
        return {
          labels: this.blockArray.map((d) => {
            return this.$utils.formatTimestamp(d.timestamp)
          }),
          datasets: [
            {
              label: 'blocks',
              fill: false,
              lineTension: 0.3,
              backgroundColor: 'rgba(75,192,192,0.4)',
              borderColor: 'rgba(75,192,192,1)',
              borderCapStyle: 'butt',
              borderDash: [],
              borderDashOffset: 0.0,
              borderJoinStyle: 'miter',
              pointBorderColor: 'rgba(75,192,192,1)',
              pointBackgroundColor: '#000',
              pointBorderWidth: 5,
              pointHoverRadius: 5,
              pointHoverBackgroundColor: 'rgba(75,192,192,1)',
              pointHoverBorderColor: 'rgba(220,220,220,1)',
              pointHoverBorderWidth: 2,
              pointRadius: 1,
              pointHitRadius: 10,
              data: this.blockArray.map(d => d.height),
              spanGaps: true
            }
          ]
        }
      }
    },
    data () {
      return {
        blockOptions: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          }
        }
      }
    }
  }
  // TODO: recharts http://recharts.org/zh-CN
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/BlocksOverview.vue